import { Directive, EventEmitter, forwardRef, HostListener, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/input';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Directive({
  selector: '[lgvDebounceClick]',
  providers: [
    { provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: DebounceClickDirective },
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DebounceClickDirective),
        multi: true,
    }
]
})
export class DebounceClickDirective {

  @Input() debounceTime = 500;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;

  constructor() { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(debounceTime(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
